<div class="page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>{{ esEdicion ? 'Editar red social' : 'Agregar red social' }}</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Red social</mat-label>
        <input matInput formControlName="redSocial" placeholder="Ej. Instagram" />
        @if (form.get('redSocial')?.hasError('required')) {
          <mat-error>La red social es obligatoria.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Usuario</mat-label>
        <input
          matInput
          formControlName="usuario"
          placeholder="Ej. https://dev.expedienteavicena.com"
        />
        @if (form.get('usuario')?.hasError('required')) {
          <mat-error>El usuario es obligatorio.</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      class="add-boton"
      mat-flat-button
      type="button"
      [disabled]="guardando"
      (click)="guardar()"
    >
      {{ esEdicion ? 'Guardar cambios' : 'Agregar' }}
      <mat-icon>{{ esEdicion ? 'save' : 'add' }}</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
